import gqlTagGira from 'graphql-tag';
import { JWM_CATEGORY_OPTIONS_FRAGMENT } from '../../common/graphql/gql.tsx';

export const CATEGORY_OPTIONS = gqlTagGira`
  query JwmCategoryOptions($projectId: ID!, $first: Int) {
    jira {
        jwmCategoryOptions(projectId: $projectId, first: $first) {
            ... on JiraWorkManagementCategoryOptionConnection {
                edges {
                    node {
                        ...JwmCategoryOptionsFragment
                    }
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                }
                totalCount
            }
            ... on QueryError {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
  }
  ${JWM_CATEGORY_OPTIONS_FRAGMENT}
`;
